/**
 * Password validation utility
 * Requirements:
 * - Minimum 8 characters
 * - At least one lowercase letter
 * - At least one uppercase letter
 * - At least one number
 * - At least one special character
 */

export const validatePassword = (password) => {
  const errors = [];

  if (password.length < 8) {
    errors.push('Legalább 8 karakter szükséges');
  }

  if (!/[a-z]/.test(password)) {
    errors.push('Legalább egy kisbetű szükséges');
  }

  if (!/[A-Z]/.test(password)) {
    errors.push('Legalább egy nagybetű szükséges');
  }

  if (!/[0-9]/.test(password)) {
    errors.push('Legalább egy szám szükséges');
  }

  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    errors.push('Legalább egy speciális karakter szükséges (!@#$%^&* stb.)');
  }

  return {
    isValid: errors.length === 0,
    errors: errors
  };
};

export const getPasswordStrength = (password) => {
  let strength = 0;

  if (password.length >= 8) strength++;
  if (password.length >= 12) strength++;
  if (/[a-z]/.test(password)) strength++;
  if (/[A-Z]/.test(password)) strength++;
  if (/[0-9]/.test(password)) strength++;
  if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) strength++;

  if (strength <= 2) return { level: 'weak', label: 'Gyenge', color: '#dc3545' };
  if (strength <= 4) return { level: 'medium', label: 'Közepes', color: '#ffc107' };
  return { level: 'strong', label: 'Erős', color: '#28a745' };
};

export const passwordRequirements = [
  'Legalább 8 karakter',
  'Legalább egy kisbetű (a-z)',
  'Legalább egy nagybetű (A-Z)',
  'Legalább egy szám (0-9)',
  'Legalább egy speciális karakter (!@#$%^&* stb.)'
];
